import React, { useState, useEffect,useRef  } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocumentsByThreadId,updateFilledDataTemplateThunk } from "../store/features/documentSlice";
import { fetchShipments } from "../store/features/shipmentsSlice";
import DocModHeader from "../components/Header/DocModHeader";
import ExtractedMustInfo from "../components/Document/ExtractedMustInfo";
import { updateShipmentStatus,updateShipmentIssue } from "../store/features/shipmentsSlice";
import EmailBody from "../components/Email/EmailBody";
import ConfirmationModal from "../components/Notification/Confirm";
import NotificationModal from "../components/Notification/Notify";

import {
    fetchEmailsData,
    setCurrentMail,
    setMailOpen
  } from "../store/features/emailsSlice";
import { decrementImportsRequiringAttentionThunk } from '../store/features/dashboardSlice';

const DocumentProcessView = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});
    const [notification, setNotification] = useState({ isOpen: false, message: "" });
    const {
        data: Emaildata,                // Renamed 'data' to 'Emaildata'
        status: Emailstatus,            // Renamed 'status' to 'Emailstatus'
        mailOpen,                       // Kept original name
        currentMail,                    // Kept original name
        pinnedEmails,                   // Kept original name
        } = useSelector((state) => state.emails);
  const { threadId, documentId } = useParams(); // Get threadId and documentId from URL
  const [automationEnabled, setAutomationEnabled] = useState(true);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef(null); // Ref for the dropdown
  const dispatch = useDispatch();
  // Fetch shipment and document data
  const handleToggleAutomation = () => {
    setAutomationEnabled((prev) => !prev);
  };
  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };
  let currentEmail = null;
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
    }
  };
  useEffect(() => {
    if (Emailstatus === "idle" && threadId && !Emaildata[threadId]) {
      dispatch(fetchEmailsData(threadId)); // Fetch emails for threadId
    }
  }, [dispatch, threadId, Emailstatus]);
  useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  const shipments = useSelector((state) => state.shipments.shipments);
  const documents = useSelector((state) => state.documents.documents[threadId]);
  const status = useSelector((state) => state.documents.status);
  const [isEmailViewerOpen, setIsEmailViewerOpen] = useState(false);
  const caseData = shipments.find((shipment) => String(shipment.shipmentId) === String(threadId));
  const MandatoryTemplate = caseData?.MandatoryData || {};

  const [selectedDocId, setSelectedDocId] = useState(documentId);
  const [documentData, setDocumentData] = useState(null);
  useEffect(() => {
      if (threadId && status === "idle") {
          dispatch(fetchDocumentsByThreadId(threadId));
      }
      if (threadId) {
          dispatch(fetchShipments());
      }
  }, [dispatch, threadId, status]);
  
  useEffect(() => {
      if (documents) {
          const initialDoc = documents.find((doc) => String(doc.documentId) === String(documentId));
          setDocumentData(initialDoc);
      }
  }, [documents, documentId]);

  // Handle document switch
  const handleDocumentSwitch = (docId) => {
      const selectedDoc = documents.find((doc) => String(doc.documentId) === String(docId));
      setSelectedDocId(docId);
      setDocumentData(selectedDoc); // Update the displayed document
  };
  const handleViewDraftEmail = () => {
    if (currentEmail) {
        setIsEmailViewerOpen(true);             // Open the modal
    } 
  };
  
  const handleCloseCase = () => {
      setModalConfig({
        title: "Close Case",
        message: "Are you sure you want to close this case?",
        onConfirm: async () => {
          try {
            await dispatch(updateShipmentStatus({ shipmentId:threadId, status: "closed" })).unwrap();
            await dispatch(updateShipmentIssue({ shipmentId:threadId }));
            setNotification({ isOpen: true, message: "Case closed successfully!" });
            // Redirect to the dashboard
            setTimeout(async () => {window.location.href = "/dashboard";}, 2000);
          } catch (error) {
            console.error("Failed to close the case:", error);
            setNotification({ isOpen: true, message: "Failed to close the case. Please try again." });
          }
          setIsModalOpen(false);
        },
      });
      setIsModalOpen(true);
    };

  // Handle loading and error states
  if (status === "loading") return <div>Loading data...</div>;
  if (status === "failed" || !documentData) return <div>Failed to load document data.</div>;
  const pdfFile = documentData?.document?.link || "";
  const emailId = documentData?.document?.emailId || "";
  if (emailId) {
    currentEmail = Emaildata[threadId]?.find(
      (email) => String(email.emailId) === String(emailId)
    );
  }
  if (currentEmail) {
    dispatch(setCurrentMail(currentEmail)); // Set the current email
    dispatch(setMailOpen(true));            // Open the email view
  }

  const { filledDataTemplate } = documentData || {};
  // Email Viewer Modal Component
const EmailViewerModal = ({ isOpen, onClose, email }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
            <div className="bg-white w-[80%] h-[80%] rounded-lg shadow-lg overflow-hidden">
                <div className="flex justify-between p-4 border-b">
                    <h2 className="text-lg font-bold">Email Draft</h2>
                    <button onClick={onClose} className="rounded-full px-3 py-1 hover:bg-bg-Gray text-lg">&times;</button>
                </div>
                <div className="p-4 overflow-auto h-[calc(100%-50px)]">
                    <EmailBody threadId={threadId} email={email} />
                </div>
            </div>
        </div>
    );
};
const hasDraftEmails = Emaildata?.[threadId]?.some((email) => email.Status === "draft");
  return (
        <div className="flex flex-col h-full"> 
            <DocModHeader
                caseId={caseData?.caseId}
                shipmentId={caseData?.shipmentId}
                origin={caseData?.origin}
                destination={caseData?.destination}
                carrier={caseData?.carrier}
                trackingNumber={caseData?.trackingNumber}
            />

            {/* Header and Actions Row */}
            <div className="pl-1 flex items-center justify-between gap-4">
                {/* Document Switch Dropdown */}
                <select
                    value={selectedDocId}
                    onChange={(e) => handleDocumentSwitch(e.target.value)}
                    className="border border-logo rounded-md p-2 text-md text-logo " 
                >
                    {documents.map((doc) => (
                        <option key={doc.documentId} value={doc.documentId}>
                            {doc.document.documentName}
                        </option>
                    ))}
                </select>

                {/* Actions Dropdown */}
                <div className="relative z-50 pr-4" ref={dropdownRef}>
                    <button
                        onClick={toggleDropdown}
                        className="border border-logo bg-white text-logo px-4 py-2 rounded-full hover:bg-bg-white hover:bg-logo hover:text-white flex items-center space-x-2"
                    >
                        <span>Actions</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="w-5 h-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 9l6 6 6-6"
                            />
                        </svg>
                    </button>
                    {dropdownVisible && (
                        <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg">
                            <button
                                onClick={handleCloseCase}
                                className="block w-full px-4 py-2 text-left text-gray-800 hover:bg-gray-100 hover:text-gray-900"
                            >
                                Close Case
                            </button>
                            <button
                                onClick={handleViewDraftEmail}
                                className={`block w-full px-4 py-2 text-left ${
                                    hasDraftEmails
                                        ? "text-gray-800 hover:bg-gray-100 hover:text-gray-900"
                                        : "text-gray-400 cursor-not-allowed"
                                }`}
                                disabled={!hasDraftEmails}
                            >
                                View Draft Email
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Main Content */}
            <div className="flex h-[calc(82%)] flex-grow border-b border-gray-300 pb-4 h-full">
                {/* Left Side - PDF Viewer */}
                <div className="w-1/2 p-2 overflow-y-hidden">
                    <iframe
                        src={pdfFile}
                        title="PDF Viewer"
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                    />
                </div>

                {/* Right Side - Extracted Info */}
                <div className="w-1/2 p-2 h-[calc(100%)] overflow-y-auto transition-all duration-300">
                <div className="text-font-hex p-4 pl-4 mb-2 text-md border border-border-document bg-bg rounded-md">
                    <strong>System was unable to locate mandatory information:</strong>
                    <p >Please review documents for missing input fields</p>
                    <div className="flex items-start space-x-2">
                        <span className="mt-2 w-1 h-1 bg-gray-800 rounded-full"></span>
                        <p>If info is available, please fill in the corresponding form field.</p>
                    </div>
                    <div className="flex items-start space-x-2">
                        <span className="mt-2 w-1 h-1 bg-gray-800 rounded-full"></span>
                        <p>
                        If info has not been provided, please follow{" "}
                        <span className="relative group inline-block">
                            <a
                            href="#"
                            onClick={hasDraftEmails ? handleViewDraftEmail : undefined}
                            className={`underline ${
                                hasDraftEmails
                                ? "hover:text-logo cursor-pointer"
                                : "text-gray-400 cursor-not-allowed"
                            }`}
                            aria-disabled={!hasDraftEmails}
                            >
                            link to drafted email
                            </a>
                            {!hasDraftEmails && (
                            <span
                                className="absolute invisible group-hover:visible bg-gray-800 text-white text-sm rounded-md px-4 py-2 w-64 z-10 transition-opacity duration-300 opacity-0 group-hover:opacity-100"
                                style={{
                                bottom: "150%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                }}
                            >
                                Draft email unavailable or already sent. Human input required.
                            </span>
                            )}
                        </span>
                        </p>
                    </div>
                </div>
                    <ExtractedMustInfo
                        dataTemplate={MandatoryTemplate}
                        threadId={threadId}
                        documentId={selectedDocId}
                        shipmentId={threadId}
                    />
                </div>
            </div>
            
            <EmailViewerModal
                isOpen={isEmailViewerOpen}
                onClose={() => setIsEmailViewerOpen(false)}
                email={currentMail}
            />

            <ConfirmationModal
                isOpen={isModalOpen}
                title={modalConfig.title}
                message={modalConfig.message}
                onConfirm={modalConfig.onConfirm}
                onCancel={() => setIsModalOpen(false)}
            />


            {/* Notification Modal */}
          <NotificationModal
            isOpen={notification.isOpen}
            message={notification.message}
            onClose={() => setNotification({ isOpen: false, message: "" })}
          />
        </div>

  );
};

export default DocumentProcessView;